///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/components/components/accessControl/values" />

export const edit = "edit";
export const view = "view";
export const hide = "hide";
